import { productName } from '@app/shared/brand'
import { Tooltip } from '../../ui'
import { Logo } from '../../ui/Logo'
import './shared-book.css'

/**
 * The strip every public Studio reader wears: the mark and the name, nothing
 * else. A public link is a reading copy, not an account, so this is chrome
 * that names the product and does not open a session.
 */
export function PublicReaderHeader() {
  return (
    <header className="public-reader-header">
      <Logo size={22} product="studio" />
      <span className="public-reader-header__name">
        {productName('studio')}
      </span>
    </header>
  )
}

/**
 * The product's mark alone, floating in the corner of a reading that has the
 * whole window — where a reader in Studio has its left rail.
 */
export function PublicReaderMark() {
  return (
    <div className="public-reader-mark">
      <Tooltip label={productName('studio')}>
        <span className="public-reader-mark__logo">
          <Logo size={18} product="studio" />
        </span>
      </Tooltip>
    </div>
  )
}
